<template>
  <v-form v-model="isValid">
    <div class="section-header text-center text-md-start mb-2 mb-md-0">
      Date posesor
    </div>
    <div class="d-flex flex-column align-center justify-center">
      <div class="mb-2 d-flex flex-column flex-md-row align-center">
        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
          {{ personalCodeQuestion.text }}
        </v-subheader>
        <div>
          <div v-if="!isMobile" style="height: 22px;"></div>
          <v-text-field
            v-model="personalCode"
            :rules="personalCodeQuestion.rules"
            :placeholder="personalCodeQuestion.placeholder"
            dense
            filled
            rounded
            solo
            flat
            class="text-input"
            @input="updateEvent"
          />
        </div>
      </div>
      <div class="mb-2 d-flex flex-column flex-md-row align-center">
        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
          {{ nameQuestion.text }}
        </v-subheader>
        <div>
          <div v-if="!isMobile" style="height: 22px;"></div>
          <v-text-field
            v-model="name"
            :rules="nameQuestion.rules"
            dense
            filled
            rounded
            solo
            flat
            class="text-input"
            @input="updateEvent"
          />
        </div>
      </div>
      <div class="mb-2 d-flex flex-column flex-md-row align-center">
        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
          {{ surnameQuestion.text }}
        </v-subheader>
        <div>
          <div v-if="!isMobile" style="height: 22px;"></div>
          <v-text-field
            v-model="surname"
            :rules="surnameQuestion.rules"
            dense
            filled
            rounded
            solo
            flat
            class="text-input"
            @input="updateEvent"
          />
        </div>
      </div>
      <div class="d-flex flex-column flex-md-row align-center">
        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
          {{ possessionTypeQuestion.text }}
        </v-subheader>
        <div>
          <div v-if="!isMobile" style="height: 22px;"></div>
          <v-autocomplete
            v-model="possessionType"
            :items="rights"
            :attach="true"
            :menu-props="{
              allowOverflow: true,
              top: true,
              nudgeBottom: 100
            }"
            dense
            filled
            rounded
            solo
            flat
            class="dropdown-input"
            placeholder="-- Selectati --"
            @change="updateEvent"
          />
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import { driverQuestions, propertyRights } from '@/_utils/static-data';
export default {
  name: 'PhysicalEntityForm',
  data() {
    return {
      personalCode: null,
      name: null,
      surname: null,
      possessionType: null,
      isValid: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    rights() {
      return propertyRights;
    },
    personalCodeQuestion() {
      return this.getQuestionById(4);
    },
    nameQuestion() {
      return this.getQuestionById(5);
    },
    surnameQuestion() {
      return this.getQuestionById(6);
    },
    possessionTypeQuestion() {
      return this.getQuestionById(3);
    }
  },
  methods: {
    getQuestionById(id) {
      return driverQuestions(id)?.[0];
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateData', {
          data: [
            {
              questionText: this.personalCodeQuestion.text,
              text: this.personalCode
            },
            {
              questionText: this.nameQuestion.text,
              text: this.name
            },
            {
              questionText: this.surnameQuestion.text,
              text: this.surname
            },
            {
              questionText: this.possessionTypeQuestion.text,
              text: this.possessionType
            }
          ],
          isValid: this.isValid && !!this.possessionType
        });
      }, 250);
    }
  }
};
</script>

<style scoped>
.section-header {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.text-input, .dropdown-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input, .dropdown-input ::v-deep .v-select__slot input {
  border: none;
}
.field-label {
  width: 180px;
}
@media screen and (max-width: 600px) {
  .field-label {
    width: 100%;
  }
  .text-input, .dropdown-input {
    width: 100%;
    min-width: 260px;
  }
}
</style>
